import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/context';
import { ReplicacheProvider } from './replicache/context';
import { ErrorBoundary } from './components/ErrorBoundary';
import { UpdateBanner } from './components/UpdateBanner';
import { Admin } from './pages/Admin';
import { Archive } from './pages/Archive';
import { AuthComplete } from './pages/AuthComplete';
import { AuthError } from './pages/AuthError';
import { AuthVerify } from './pages/AuthVerify';
import { Contacts } from './pages/Contacts';
import { EmbedView } from './pages/EmbedView';
import { Home } from './pages/Home';
import { Notifications } from './pages/Notifications';
import { Reports } from './pages/Reports';
import { Settings } from './pages/Settings';
import { SharedView } from './pages/SharedView';
import { SharedWithMeList, SharedWithMeViewer } from './pages/SharedWithMe';
import { SignIn } from './pages/SignIn';

export function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                {/* Sits outside the routes so the banner persists across navigations
            and works on both authed and public pages.  useReplicache()
            inside the banner returns null when there's no provider, and
            the banner just falls back to a no-pending-check countdown. */}
                <UpdateBanner />
                <Routes>
                    {/* Public share viewer — outside the auth/replicache providers so
              anonymous viewers don't trigger a sign-in flow. */}
                    <Route path="/shared/:token" element={<SharedView />} />
                    {/* Compact read-only task list for embedding in an Excalidraw
              web-embed box.  Also public (token-gated) and outside the
              auth/replicache providers. */}
                    <Route path="/embed/:token" element={<EmbedView />} />
                    {/* Everything else lives behind auth + Replicache. */}
                    <Route
                        path="*"
                        element={
                            <AuthProvider>
                                <ReplicacheProvider>
                                    <Routes>
                                        <Route path="/" element={<Home />} />
                                        <Route
                                            path="/admin"
                                            element={<Admin />}
                                        />
                                        <Route
                                            path="/settings"
                                            element={<Settings />}
                                        />
                                        <Route
                                            path="/notifications"
                                            element={<Notifications />}
                                        />
                                        <Route
                                            path="/reports"
                                            element={<Reports />}
                                        />
                                        <Route
                                            path="/archive"
                                            element={<Archive />}
                                        />
                                        <Route
                                            path="/contacts"
                                            element={<Contacts />}
                                        />
                                        <Route
                                            path="/shared-with-me"
                                            element={<SharedWithMeList />}
                                        />
                                        <Route
                                            path="/shared-with-me/:id"
                                            element={<SharedWithMeViewer />}
                                        />
                                        <Route
                                            path="/signin"
                                            element={<SignIn />}
                                        />
                                        <Route
                                            path="/auth/verify"
                                            element={<AuthVerify />}
                                        />
                                        <Route
                                            path="/auth/complete"
                                            element={<AuthComplete />}
                                        />
                                        <Route
                                            path="/auth/error"
                                            element={<AuthError />}
                                        />
                                        <Route
                                            path="*"
                                            element={
                                                <Navigate to="/" replace />
                                            }
                                        />
                                    </Routes>
                                </ReplicacheProvider>
                            </AuthProvider>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}
